export default class GetWorkTypeByIdError extends Error {

}
